<template>
  <v-data-table
    :headers="headers"
    :items="mezzi"
    :show-select="Boolean(this.showSelect)"
    item-key="descrizione"
    value="mezzi"
    :sort-by="['descrizione']"
    :sort-desc="false"
    :loading="loading"
    :search="search"
    class="elevation-1"
    v-model="selectedItems"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Mezzi</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          class="mx-5"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-dialog v-model="dialog" max-width="800px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Nuovo
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-card-text>
                    <v-container>
                      <v-text-field
                        label="Descrizione"
                        type="text"
                        v-model="editedMezzi.descrizione"
                      ></v-text-field>
                    </v-container>
                  </v-card-text>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
              <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="600px">
          <v-card>
            <v-card-title class="headline"
              >Are you sure you want to delete this vehicle?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
      <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
    </template>

    <v-snackbar v-model="ShowSnackbar" :timeout="5000">
      {{ error }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error = ''">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-data-table>
</template>
<script>
import EasyPlanClient from "../../utils/EasyPlanClient";
export default {
  props: ["showSelect", "selectedVehicles"],
  data: () => ({
    dialog: false,
    dialogDelete: false,
    error: "",
    search: "",
    loading: false,
    headers: [
      { text: "Descrizione", value: "descrizione" },

      { text: "Actions", value: "actions", sortable: false },
    ],
    mezzi: [],
    selectedItemsArr: [],
    editedIndex: -1,
    editedMezzi: {
      descrizione: "",
    },
    defaultItem: {
      descrizione: "",
    },
  }),

  computed: {
    selectedItems: {
      get() {
        return this.selectedItemsArr;
      },
      set(value) {
        this.selectedItemsArr = value;
        console.debug("raising event itemSelected...");
        this.$emit("item-selected", this.selectedItemsArr);
      },
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Vehicle" : "Edit Vehicle";
    },
    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    selectedVehicles(value) {
      console.debug("Vehicles changed");
      this.selectedItemsArr = value;
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    resetFormData: function () {
      this.editedMezzi = {
        descrizione: "",
      };
    },
    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
      this.loadVehicles();
    },

    loadVehicles() {
      this.loading = true;
      console.log("loading vehicles...");
      EasyPlanClient.Resources.GetAllVehicles(this.$route.params.companyAlias)
        .then((res) => {
          this.mezzi = res.data.data;
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    insertVehicle(vehicle) {
      EasyPlanClient.Resources.Insert(
        this.$route.params.companyAlias,
        vehicle.descrizione,
        1
      )
        .then((res) => {
          console.debug("risposta add vehicle:");
          console.debug(res);
          this.mezzi.push(res.data.data);
          this.loadVehicles();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    editVehicle(vehicle) {
      EasyPlanClient.Resources.Update(this.$route.params.companyAlias, vehicle)
        .then((res) => {
          console.debug("risposta edit vehicle:");
          console.debug(res);
          this.loadVehicles();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.mezzi.indexOf(item);
      this.editedMezzi = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.mezzi.indexOf(item);
      this.editedMezzi = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      EasyPlanClient.Resources.Delete(
        this.$route.params.companyAlias,
        this.editedMezzi.idRisorsa
      ).then((res) => {
        this.mezzi.splice(this.editedIndex, 1);
        this.closeDelete();
      });
    },

    close() {
      this.resetFormData(); 
      this.dialog = false;
    },

    closeDelete() {
      this.resetFormData();  
      this.dialogDelete = false;
    },

    save() {
      if (this.editedIndex > -1) {
        this.editVehicle(this.editedMezzi);
        Object.assign(this.mezzi[this.editedIndex], this.editedMezzi);
      } else {
        this.insertVehicle(this.editedMezzi);
      }
      this.close();
    },
  },
};
</script>